import React from "react";
import NavBarDropdown from "./NavBarDropDown"
import {NavBarDesktopV1} from "./NavBarDesktopV1";
import useViewport from "../Utils/useViewPort"
import FullScreen from "../MainContent/FullScreen";
import { useState, useEffect } from "react";


const NavBar = () => {

  const viewPort = useViewport();
  const isMobile = viewPort.width <= 1024;
  // const [showFull, setShowFull] = useState(false);
  // const showHandler = () => {
  //   setShowFull(!showFull)
  // }
  
  return (
    <>
      {isMobile ? <NavBarDropdown /> : <></>}
      {!isMobile ? <NavBarDesktopV1 /> : <></>}
 
    </>
  )

}

export default NavBar;

